export type UpdateComponentConversionRulesRequest = {
  envCopyCpntAttrCnvRules: EnvCopyCpntAttrCnvRuleWithIdx[];
};

export type EnvCopyCpntAttrCnvRuleWithIdx = {
  idx: number;
  cpntAttrCnvRuleId: string;
  envrnmntIdFrom: string;
  envrnmntIdTo: string;
  cpntAttrNum: string;
  cpntId: string;
  cpntAttrCnvRuleTypeCd: string;
  rplcmntFromAttrStngVal: string;
  rplcmntToAttrStngVal: string;
  attrStngVal: string;
  updateDateTime?: string;
};
